export const MUTATION_REVOKE_ABO = /* GraphQL */ `
	mutation (
		$aboId: String
		$refundTransactions: Boolean
		$profileId: String!
		$revokeDate: String
	) {
		revokeAbo(
			aboId: $aboId
			refundTransactions: $refundTransactions
			profileId: $profileId
			revokeDate: $revokeDate
		)
	}
`;
